import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupersetDashboardRoutingModule } from './superset-dashboard-routing.module';
import { SupersetDashboardComponent } from './superset-dashboard.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from '../shared/shared.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialModule } from '../core/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SupersetComponent } from './superset/superset.component';
import { DashMenuComponent } from './dash-menu/dash-menu.component';


@NgModule({
  declarations: [
    SupersetDashboardComponent,
    SupersetComponent,
    DashMenuComponent
  ],
  imports: [
    CommonModule,
    SupersetDashboardRoutingModule,
    MaterialModule,
    SharedModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
  ],
})
export class SupersetDashboardModule { }
